export function InfoSection({ title, count, className = "", children }) {
  return (
    <section className={`ds-info-section${className ? ` ${className}` : ""}`}>
      <div className="ds-info-section-head">
        <h3>{title}</h3>
        {count != null && <span>{count}</span>}
      </div>
      {children}
    </section>
  );
}

export function DescriptionList({ items, columns = 3, className = "" }) {
  return (
    <dl className={`ds-description-list ds-description-list--${columns}${className ? ` ${className}` : ""}`}>
      {items.map((item) => (
        <div key={item.label} className={item.className || ""}>
          <dt>{item.label}</dt>
          <dd>{item.value || "-"}</dd>
        </div>
      ))}
    </dl>
  );
}
